<script lang="ts">
  import { applyAction, enhance } from '$app/forms';
  import { refreshAll } from '$app/navigation';
  import FloatingLabel from '#lib/components/FloatingLabel.svelte';
  import Modal from '#lib/components/Modal.svelte';

  let {
    systems,
    datacenter = null,
    open = $bindable(false),
  }: {
    systems: { id: number; name: string }[];
    datacenter?: { id: number; name: string } | null;
    open: boolean;
  } = $props();

  let resultData: { system?: { error: Record<string, string | string[]> } } = $state({});
  let errors = $derived(resultData.system?.error);
</script>

<Modal header={'Add a system' + (datacenter ? ` to ${datacenter.name}` : '')} bind:open>
  <form
    method="post"
    action="?/system"
    use:enhance={() => {
      return async ({ result }) => {
        await applyAction(result);

        if (result.type === 'success') {
          await refreshAll();
          open = false;
        } else if (result.type === 'failure') {
          resultData = result.data ?? {};
        }
      };
    }}
  >
    <input type="number" value={datacenter?.id ?? -1} name="datacenterId" hidden class="hidden" />
    <section class="grid gap-6">
      <FloatingLabel title="Name" error={errors?.name}>
        {#snippet input(placeholder)}
          <input name="name" class="input w-full" required {placeholder} />
        {/snippet}
      </FloatingLabel>
      <FloatingLabel title="Clone from" error={errors?.cloneId}>
        {#snippet input()}
          <select name="cloneId" class="select w-full">
            <option value="-1">None</option>
            {#each systems as system}
              <option value={system.id}>{system.name}</option>
            {/each}
          </select>
        {/snippet}
      </FloatingLabel>
    </section>
    <div class="modal-action">
      <button class="btn btn-secondary btn-ghost" type="reset" onclick={() => (open = false)}>
        Cancel
      </button>
      <button type="submit" class="btn btn-primary">Submit</button>
    </div>
  </form>
</Modal>
